import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Radio, Header } from 'semantic-ui-react';
import styles from './CreditorSelect.module.scss';

const CreditorSelect = ({ onCreditorSelect, vehicle, onCancel, onBack, confirmMessage, message }) => {
	const [selectedCreditor, setSelectedCreditor] = useState(null);

	const [showConfirm, setShowConfirm] = useState(false);
	const [open, setOpen] = useState(false);

	const onConfirm = useCallback(() => {
		onCreditorSelect(selectedCreditor);
	}, [onCreditorSelect, selectedCreditor]);

	const onContinue = useCallback(() => {
		if (confirmMessage) {
			setShowConfirm(true);
		} else {
			onCreditorSelect(selectedCreditor);
		}
	}, [confirmMessage, onCreditorSelect, selectedCreditor]);

	useEffect(() => {
		if(vehicle.creditors.length === 1) {
			onCreditorSelect(vehicle.creditors[0]);
		}
	}, [onCreditorSelect, vehicle.creditors])

	return (
		<div>
			<Modal open={showConfirm} onClose={() => setShowConfirm(false)} size='tiny'>
				<Modal.Header>Confirm</Modal.Header>
				<Modal.Content>{confirmMessage}</Modal.Content>
				<Modal.Actions>
					<Button id="yesBtn" primary onClick={onConfirm}>
						Yes
					</Button>
					<Button id="noBtn" primary onClick={() => setShowConfirm(false)}>
						No
					</Button>
				</Modal.Actions>
			</Modal>
			<Modal open={open} onClose={() => setOpen(false)} size='tiny'>
				<Modal.Header>Warning</Modal.Header>
				<Modal.Content>{confirmMessage}</Modal.Content>
				<Modal.Actions>
					<Button id="closeBtn" primary onClick={() => setOpen(false)}>
						Close
					</Button>
				</Modal.Actions>
			</Modal>
			<Header>{message}:</Header>
			<Form>
				{vehicle.creditors.map((creditor, i) => {
					return <Form.Field key={i} id={`creditor${i}_radio`} control={Radio} label={`${creditor.businessName} ${creditor.firstName} ${creditor.lastName}`} checked={creditor === selectedCreditor} onChange={() => setSelectedCreditor(creditor)} />;
				})}
			</Form>
			<div className={styles.buttons}>
				<Button id="continueBtn" primary disabled={!selectedCreditor} onClick={onContinue}>
					Continue
				</Button>
				<Button id="cancelBtn" primary onClick={onCancel}>
					Cancel
				</Button>
				{onBack && (
					<Button id="backBtn" primary onClick={onBack}>
						Back
					</Button>
				)}
			</div>
		</div>
	);
};

CreditorSelect.propTypes = {
	onCreditorSelect: PropTypes.func.isRequired,
	vehicle: PropTypes.any.isRequired,
	onCancel: PropTypes.func.isRequired,
	onBack: PropTypes.func,
	confirmMessage: PropTypes.string,
	message: PropTypes.string,
};

export default CreditorSelect;
